import { StringUtility, anyPromiseTrackerTagsInProgress } from "@common/utils";
import classNames from "classnames";
import React from "react";
import { Button, ButtonProps, OverlayTrigger, Tooltip } from "react-bootstrap";

interface ISuspenseButtonProps extends ButtonProps {
    tag?: string
    tags?: string[]
    className?: string
    hideSpinner?: boolean
    disabled?: boolean
}


export const SuspenseButton = ({ tag, tags, children, className, hideSpinner = false, disabled, title, ...buttonProps }: React.PropsWithChildren<ISuspenseButtonProps>) => {
    // get a single list of promise tags to watch
    const promiseTags = tags ?? [];
    if (tag) { promiseTags.push(tag); }
    // are any of the promise tags in progress?
    const promiseInProgress = anyPromiseTrackerTagsInProgress(promiseTags);

    const button =
        <Button
            className={classNames(className, promiseInProgress && !hideSpinner && 'button-loading')}
            disabled={promiseInProgress || disabled}
            {...buttonProps}>
            {children}
        </Button>

    // if a title was provided, provide a tooltip overlay.
    // otherwise just return the button.
    if (StringUtility.hasValue(title)) {
        return <OverlayTrigger
            overlay={<Tooltip>{title}</Tooltip>}>
            <span className="d-inline-block">
                {button}
            </span>
        </OverlayTrigger>
    } else {
        return button;
    }
}
